import React from "react";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";

const useStyles = makeThemedStyles("PerspectiveCardList", (theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    columnGap: "32px",
    flexDirection: "row",
    flexWrap: "wrap",
  },
}));

const PerspectiveCardList = (props: React.PropsWithChildren<{}>) => {
  const classes = useStyles();
  return <div className={classes.root}>{props.children}</div>;
};

export default PerspectiveCardList;
